export default "__VITE_ASSET__D5pX1v4Y__"